"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceService = void 0;
const RegisteredDevice_1 = __importDefault(require("../device/RegisteredDevice"));
const api_1 = require("./api");
const PATH_V1 = '/device/api/v1';
class DeviceService {
    static async registerDevice(data) {
        try {
            const payload = await api_1.API.post({
                url: `${PATH_V1}/device-info`,
                body: data.getPostData()
            });
            return RegisteredDevice_1.default.buildFromPayload(payload);
        }
        catch (e) {
            throw e;
        }
    }
    static async updateDevice(data) {
        try {
            const payload = await api_1.API.put({
                url: `${PATH_V1}/device-info`,
                body: data.getUpdateData()
            });
            return RegisteredDevice_1.default.buildFromPayload(payload);
        }
        catch (e) {
            throw e;
        }
    }
    static async linkDevice(data) {
        try {
            return await api_1.API.put({
                url: `${PATH_V1}/device-info/link`,
                body: data
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async appReviewGet() {
        try {
            return await api_1.API.get({
                url: `${PATH_V1}/app-review`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async appReviewPost(data) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/app-review`,
                body: data
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.DeviceService = DeviceService;
//# sourceMappingURL=device-service.js.map